import { IIsShareHintShowSetAction } from './types';
import { AT_IS_SHARE_HINT_SHOW_SET } from './constants';

export const isShareHintShowSetAction = (
    isShareHintShow: boolean
): IIsShareHintShowSetAction => ({
    type: AT_IS_SHARE_HINT_SHOW_SET,
    isShareHintShow
});
